
import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import IBAN from 'iban';
import { Connection, PermissionCode, User } from '@/types';
import { currentUserHasPermission } from '@/helpers';

moment.locale('it');

@Component
export default class UtilsMixin extends Vue {
  get currentUser(): User {
    return this.$store.getters.currentUser;
  }

  get isConnectionLoading(): boolean {
    return this.$store.getters.isConnectionLoading;
  }

  get currentConnection(): Connection | null {
    return this.$store.getters.currentConnection;
  }

  updatedAtLong(updatedAt: Date | null, updatedBy: string | null) {
    return updatedAt && updatedBy
      ? `Ultima modifica: ${moment(updatedAt).format('L')} ore ${moment(updatedAt).format('LT')} `
        + `(${updatedBy ?? 'Sconosciuto'})`
      : '';
  }

  hasPermission(codename: PermissionCode): boolean { return currentUserHasPermission(codename); }

  mDate(date: Date | null | undefined): string | null { return date ? moment(date).format('L') : null; }

  mWeek(date: Date | null | undefined): string | null {
    return date ? `Settimana ${moment(date).format('WW')}-${moment(date).format('GGGG')}` : null;
  }

  isBlank(str: string | null) {
    return !str || /^\s*$/.test(str);
  }

  ibanRules(iban: string | null) {
    if (this.isBlank(iban)) return [true];

    return [
      (v: string) => IBAN.isValid(v) || "L'IBAN inserito non è corretto",
    ];
  }

  podRules(pod: string | null) {
    if (this.isBlank(pod)) return [true];

    const podRegex = /^IT\d\d\dE\d\d\d\d\d\d\d\d(\d)?$/i;
    const fixedPod = pod !== null ? pod.replace(/ /g, '').toLowerCase() || '' : '';

    return [podRegex.test(fixedPod) || 'Il POD inserito non è corretto'];
  }

  getForm(formRef: Vue | Element | Vue[] | Element[]): (
    Vue & { validate: () => boolean; reset: () => boolean }
  ) | undefined {
    return formRef as Vue & {
      validate: () => boolean;
      reset: () => boolean;
    };
  }

  getCalendar(calendarRef: Vue): (
    Vue & {
      now: string | null;
      title: string | null;
      prev: (amount?: number) => void;
      next: (amount?: number) => void;
    }
  ) | undefined {
    return calendarRef as Vue & {
      now: string | null;
      title: string | null;
      prev: (amount?: number) => void;
      next: (amount?: number) => void;
    };
  }
}
